if (!customElements.get('ripe-sticky-atc')) {
  class RipeStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sourceButton = document.querySelector('[id^="ProductSubmitButton-"]');
      this.productInfo = document.querySelector('product-info');
      this.footer = document.querySelector('footer');
      this.cartDrawer = document.querySelector('cart-drawer');

      if (!this.sourceButton || !this.productInfo) return;

      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-ripe-sticky-label]');
      this.price = this.querySelector('[data-ripe-sticky-price]');
      this.button.addEventListener('click', () => this.sourceButton.click());

      this.sync();
      this.buttonObserver = new MutationObserver(() => this.sync());
      this.buttonObserver.observe(this.sourceButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      this.priceSource = this.productInfo.querySelector('[id^="price-"]');
      if (this.priceSource) {
        this.priceObserver = new MutationObserver(() => this.sync());
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true });
      }

      this.onViewportChange = () => {
        window.requestAnimationFrame(() => this.toggle());
      };
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);

      if (this.cartDrawer) {
        this.cartObserver = new MutationObserver(() => this.toggle());
        this.cartObserver.observe(this.cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }

      this.toggle();
    }

    disconnectedCallback() {
      this.buttonObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.cartObserver?.disconnect();
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
    }

    sync() {
      this.button.disabled = this.sourceButton.disabled;
      this.label.textContent = this.sourceButton.querySelector('span')?.textContent.trim() || 'Add to cart';
      const currentPrice = this.priceSource?.querySelector('.price-item--sale, .price-item--regular');
      this.price.textContent = currentPrice?.textContent.trim() || '';
    }

    toggle() {
      const sourcePassed = this.sourceButton.getBoundingClientRect().bottom < 0;
      const cartOpen = this.cartDrawer?.classList.contains('active');
      const footerRect = this.footer?.getBoundingClientRect();
      const footerVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
      const mediaModalOpen = document.querySelector('product-modal[open], dialog[open], .product-media-modal[open]');
      const shouldShow =
        window.matchMedia('(max-width: 749px)').matches &&
        sourcePassed &&
        !footerVisible &&
        !cartOpen &&
        !mediaModalOpen;
      this.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('ripe-sticky-atc-visible', shouldShow);

      const chatImage = document.querySelector('img[alt="Chat"]');
      let chatWidget = chatImage;
      while (chatWidget?.parentElement && chatWidget.parentElement !== document.body) {
        if (window.getComputedStyle(chatWidget).position === 'fixed') break;
        chatWidget = chatWidget.parentElement;
      }
      chatWidget?.classList.toggle('ripe-chat-widget--suppressed', shouldShow || cartOpen);
    }
  }

  customElements.define('ripe-sticky-atc', RipeStickyAtc);
}

document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo || document.querySelector('ripe-sticky-atc')) return;

  const stickyBar = document.createElement('ripe-sticky-atc');
  stickyBar.className = 'ripe-sticky-atc color-scheme-1';
  stickyBar.innerHTML = `
    <div class="ripe-sticky-atc__details">
      <span class="ripe-sticky-atc__title">${document.querySelector('.product__title h1')?.textContent.trim() || ''}</span>
      <span class="ripe-sticky-atc__price" data-ripe-sticky-price></span>
    </div>
    <button class="button button--primary" type="button"><span data-ripe-sticky-label>Add to cart</span></button>
  `;
  document.body.appendChild(stickyBar);

  const hideEmptyProductReviews = () => {
    const reviewWidget = document.querySelector('#MainContent .jdgm-review-widget');
    if (!reviewWidget) return false;

    const reviewContainer = reviewWidget.querySelector('.jdgm-rev-widg');
    const previewBadge = document.querySelector('.product__info-container .jdgm-prev-badge');
    const reviewCountValue =
      reviewContainer?.dataset.numberOfReviews ??
      reviewWidget.dataset.numberOfReviews ??
      previewBadge?.dataset.numberOfReviews;
    const reviewCount = Number(reviewCountValue);

    if (Number.isFinite(reviewCount) && reviewCount === 0) {
      reviewWidget.closest('.shopify-section')?.classList.add('ripe-product-reviews--empty');
    }

    return Number.isFinite(reviewCount);
  };

  if (!hideEmptyProductReviews()) {
    const reviewsObserver = new MutationObserver(() => {
      if (hideEmptyProductReviews()) reviewsObserver.disconnect();
    });
    reviewsObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => reviewsObserver.disconnect(), 10000);
  }
});
